import dateUtils from "@/utils/date";

export const defiCardProps = () => ({
  defi: {
    type: Object,
    required: false,
    default: null
  },
  isTermine: {
    type: Boolean,
    required: false,
    default: false
  },
  isAvenir: {
    type: Boolean,
    required: false,
    default: false
  },
  lastAdhesionIsReussi: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useDefiCard = (props) => {

  const dateContent = computed(() => {
    return `Du ${dateUtils.formatDateWithoutYear(
      props.defi.attributes.date_debut
    )} au ${dateUtils.formatDateMonth(props.defi.attributes.date_fin)}`;
  });

  return { dateContent }
}